import C7Init from "./commerce7/c7";
import Modules from "./modules/modules";
import BOT_GiftSet from "./modules/gift-set-builder";

new C7Init().init();
new Modules().init();
new BOT_GiftSet().init();

jQuery(document).ready(function ($) {
    $('.ios-click').on('touchstart click', function (event) {
        event.preventDefault();
        window.location.href = $(this).attr('href');
    });
    var prevButton = document.querySelector('.owl-prev');
    var nextButton = document.querySelector(".owl-next");
    if (prevButton) {
        prevButton.setAttribute('aria-label', 'Previous');
    }
    if (nextButton) {
        nextButton.setAttribute('aria-label', 'Next');
    }
    jQuery(".bot__text a").click(function (event) {
        event.preventDefault();
        var href = jQuery(this).attr("href");
        var target = jQuery(this).attr("target");
        if (href.indexOf("#") === -1) {
            if (target) {
                window.open(href, target);
                return;
            }
            window.location.href = href;
            return;
        }
        if (href.replace("#", "")) {
            jQuery(window).width();
            var spacingTop = jQuery("html, body").animate(
                {
                    scrollTop: jQuery(href).offset().top - 60,
                },
                500
            );
        }
    });
    jQuery(".mobile-hamburger").on("click", function () {
        jQuery(".mobile-side-menu").toggleClass("opened");
        jQuery(".mobile-side-menu").slideDown();
        jQuery(".menu-outside").toggleClass("d-none");
        jQuery("body").toggleClass("scroll-disabled");
    });
    jQuery(".menu-outside, .hide-mobile-menu").on("click", function () {
        jQuery(".mobile-side-menu").toggleClass("opened");
        jQuery(".mobile-side-menu").slideUp();
        jQuery(".menu-outside").toggleClass("d-none");
        jQuery("body").toggleClass("scroll-disabled");
    });

    jQuery(document).on("keyup", function (e) {
        if (!jQuery(".mobile-side-menu").hasClass('opened')) return;
        if (27 !== e.which) return;
        jQuery(".mobile-side-menu").toggleClass("opened");
        jQuery(".mobile-side-menu").slideUp();
        jQuery(".menu-outside").toggleClass("d-none");
        jQuery("body").toggleClass("scroll-disabled");
    });

    jQuery(".view-cart-side-menu a").click(function () {
        jQuery('#c7-cart button.c7-link').click();
    });

    const checkFooter = () => {
        const windowHeight = jQuery(window).height();
        const contentHeight = jQuery("body").height();
        const footerHeight = jQuery("footer").height();
        if (jQuery("footer").hasClass("sticky")) {
            if (windowHeight < contentHeight + footerHeight) {
                jQuery("footer").removeClass("sticky");
            }
        } else {
            if (windowHeight > contentHeight) {
                jQuery("footer").addClass("sticky");
            }
        }
    };

    if (jQuery("#c7-content").length == 0) {
        checkFooter();
    }

    jQuery(window).resize(function () {
        checkFooter();
    });

    jQuery('.container-popup .popup-close').click(function () {
        jQuery(this).closest('.container-popup').hide();
    });

    jQuery('.popup-btn').click(function () {
        let popupID = jQuery(this).data('control');
        let ID = jQuery(this).attr('id');
        let button = jQuery(popupID).data('button');
        if (ID === button) {
            jQuery(popupID).show();
        }
    });

    jQuery('.open-redchirp').click((e) => {
        e.preventDefault();
        jQuery('#redchirp-iframe').toggleClass('show');
    });

    //jQuery('.button-link .button').html('<span>' + jQuery('.button-link .button').html() + '</span>');
    let item = 5;
    let m_item = 3;
    if (jQuery('.owl_sales_support_materials .c7-product').length == 1) {
        item = 1;
        m_item = 1;
    } else if (jQuery('.owl_sales_support_materials .c7-product').length == 2) {
        item = 2;
        m_item = 2;
    } else if (jQuery('.owl_sales_support_materials .c7-product').length == 3) {
        item = 3;
    } else if (jQuery('.owl_sales_support_materials .c7-product').length == 4) {
        item = 4;
    }
    if (jQuery('.owl_sales_support_materials').length) {
        jQuery('.owl_sales_support_materials').owlCarousel({
            loop: false,
            margin: 10,
            nav: true,
            //center: true,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: m_item
                },
                1000: {
                    items: item
                }
            }
        });
        jQuery('.owl_sales_support_materials .owl-prev').html('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 1L6 12L17 23C17 23 14.97 16.455 15 12C15.0291 7.6877 17 1 17 1Z" fill="#20282B"></path></svg>');
        jQuery('.owl_sales_support_materials .owl-next').html('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1L19 12L8 23C8 23 10.03 16.455 10 12C9.97095 7.6877 8 1 8 1Z" fill="#20282B"></path></svg>');
    }

    jQuery('.show-search-btn').click(function () {
        jQuery('.search-field').addClass('show');
        jQuery('.hide-search-btn').addClass('show');
        jQuery(this).removeClass('show');
    });

    jQuery('.hide-search-btn').click(function () {
        jQuery('.search-field').removeClass('show');
        jQuery('.show-search-btn').addClass('show');
        jQuery(this).removeClass('show');
    });

    function controlShowMore() {
        if (jQuery('#myBtnContainer').innerHeight() <= 50) {
            jQuery('.show-filter').removeClass('show');
        } else {
            jQuery('.show-filter').addClass('show');
        }
    }

    controlShowMore();
    jQuery(window).resize(controlShowMore);

    jQuery('.show-filter').click(function () {
        jQuery('.filter-wrap-inner').toggleClass('show-more');
        jQuery(this).toggleClass('less');
        if (jQuery(this).hasClass('less')) {
            jQuery(this).find('.more').hide();
            jQuery(this).find('.less').show();
        } else {
            jQuery(this).find('.more').show();
            jQuery(this).find('.less').hide();
        }

    })
    if (jQuery('.other_stories_carousel').length) {
        jQuery('.other_stories_carousel').owlCarousel({
            loop: false,
            nav: true,
            dots: false,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 2
                }
            }
        });
        jQuery('.other_stories_carousel .owl-prev').html('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 1L6 12L17 23C17 23 14.97 16.455 15 12C15.0291 7.6877 17 1 17 1Z" fill="#20282B"></path></svg>');
        jQuery('.other_stories_carousel .owl-next').html('<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 1L19 12L8 23C8 23 10.03 16.455 10 12C9.97095 7.6877 8 1 8 1Z" fill="#20282B"></path></svg>');
    }

    c7.addAction("c7_cart_carrots_rendered", (content) => {
        // Do something after collection rendered.
        setInterval(cartCarrot, 400)
    });

    const createStepElement = (index, active) => {
        const step = document.createElement('div');
        step.classList.add("step");

        if (index === 0) {
            step.classList.add("start");
        }
        if (0 < active && index < active) {
            step.classList.add("step");
        }
        if (index === active) {
            step.classList.add("curent-step");
        }
        if (index <= active) {
            step.classList.add("active");
        }

        return step;
    };

    const createStepText = (index) => {
        const stepText = document.createElement('div');
        stepText.appendChild(document.createTextNode(index));
        return stepText;
    };

    const cartCarrot = () => {
        const wrapLine_list = document.querySelectorAll('.line-bar');
        if (!wrapLine_list.length) return;

        wrapLine_list.forEach(wrapLines => {

            const bound = Number(wrapLines.getAttribute('data-total'));
            const active = Number(wrapLines.getAttribute('data-step'));
            
            const lines = document.createElement('div');
            lines.classList.add("l-step");
            
            const text = document.createElement('div');
            text.classList.add("t-step");
            
            wrapLines.innerHTML = '';

            for (let index = 0; index <= bound; index++) {
                const step = createStepElement(index, active);
                const stepText = createStepText(index);

                lines.appendChild(step);
                text.appendChild(stepText);
            }

            wrapLines.appendChild(lines);
            wrapLines.appendChild(text);
        });
    };

    if(document.querySelector('.c7-cart')) {
        setInterval(cartCarrot, 400);
    }
});
